export const CLIENT_HOMEPAGE_LINK = "https://www.einza.com/"
